import { getLocaleFromNavigator } from 'svelte-i18n';

export class config {
  static get language() {
    return localStorage.getItem('app_lang') || getLocaleFromNavigator()
  }

  static set language(lang_id) {
    localStorage.setItem('app_lang', lang_id)
  }

  static get version() {
    return '1.1.0'
  }
}